import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
// components
import { useAuth0 } from "@auth0/auth0-react";
// import LoadingScreen from 'src/components/loading-screen';
import { Login } from "./components/index";
//
import { useAuthContext } from "./useAuthContext";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";

// Don't block UI forever when Auth0 hangs (e.g. authorize returns 400)
const AUTH_LOADING_TIMEOUT_MS = 8000;

// ----------------------------------------------------------------------

export const AuthGuard = ({ children }) => {
  const { isInitialized, user } = useAuthContext();
  const { isLoading, isAuthenticated } = useAuth0();

  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const [loadingTimedOut, setLoadingTimedOut] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setLoadingTimedOut(false);
      return;
    }
    const t = setTimeout(() => setLoadingTimedOut(true), AUTH_LOADING_TIMEOUT_MS);
    return () => clearTimeout(t);
  }, [isLoading]);

  const showLoading = isLoading && !loadingTimedOut;

  if (showLoading) {
    return <LoadingScreen />;
  }

  if (!isInitialized && !loadingTimedOut) {
    return <LoadingScreen />;
  }
  if (!isAuthenticated || loadingTimedOut) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    return <Login returnTo={pathname} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
